<template>
  <div class="content">
    <!-- 新增按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin: 0 0 10px 0px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
          >导出 Excel（数量/ {{ dataList.length }}条）</el-button
        >
      </el-form-item>
      <el-form-item label="门店: " style="margin-left:20px" required>
        <el-select
          style="width:800px"
          multiple
          v-model="selectStoreList"
          placeholder="请选择"
          @change="storeChange"
          clearable
        >
          <el-option
            v-for="item in storeList"
            :label="item.storeName"
            :value="item.id + ''"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height: 80%">
      <el-table
        border
        :data="dataList"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        :header-cell-style="{ background: '#e8effc', color: '#000' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="会员卡号" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.vip_number }}</span>
          </template>
        </el-table-column>
        <el-table-column label="会员卡类型" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.type }}</span>
          </template>
        </el-table-column>

        <el-table-column label="手机号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.user_phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易金额" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="消费时间" align="center" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.message ? scope.row.message : "暂无备注"
            }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="身份权限" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.grade==0?"员工":"店长" }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="ejectupdataGoods(scope.row)"
              >修改</el-button
            >
            <el-button size="mini" type="danger" @click="deleteAdmin(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!-- 新增表单 -->
    <el-dialog
      :title="inputTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="店铺名称">
          <el-input v-model="form.storeName" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="店长/员工 姓名">
          <el-input v-model="form.storeName" auto-complete="off"></el-input>
        </el-form-item>
         <el-form-item label="手机号">
          <el-input v-model="form.storePhone" auto-complete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="店铺地址">
          <el-input
            type="textarea"
            v-model="form.storeAdress"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { selectVipcardrecode } from "@/services/vipUser.js";
import { selectStore } from "@/services/store";
export default {
  data() {
    return {
      downloadLoading: false,
      storeName: "", //店铺名称搜索条件
      dataList: [],
      inputTitle: "新增",
      cover: "",
      fileList: [],
      action: "https://mini-xili.bboycc.cn/uploadFile/add",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" },
      ],
      form: {},
      dialogFormVisible: false,
      storeList: [],
      selectStoreList: [],
    };
  },
  created() {
    // 查询用户登陆数据
    this.form.storeId = this.$store.state.supUser.storeId;
    selectStore({ storeName: "" }).then((res) => {
      if (this.$store.state.supUser.role_id === "0") {
        /* 店长 */
        this.selectFun();
        this.storeList = res.data;
        return;
      }
      /* 员工 */
      this.selectStoreList = this.form.storeId?.split(",");
      this.storeList = this.selectStoreList?.map((item) => {
        let result = res.data?.find((value) => {
          console.log(value);
          return value.id == item;
        });
        this.selectFun();
        return result;
      });
    });
  },
  methods: {
    // 查询
    selectFun() {
      selectVipcardrecode({ storeId: this.selectStoreList?.join(",") }).then(
        (resp) => {
          console.log(resp.data);
          this.loading = false;
          this.dataList = resp.data.data;
        }
      );
    },
    storeChange() {
      this.selectFun();
    },
    // 新增按钮
    kaihuBtn() {
      this.inputTitle = "新增";
      this.dialogFormVisible = true;
      this.form = {};
    },
    ejectupdataGoods(row) {
      console.log(row);
      this.form = {};
      this.dialogFormVisible = true;
      this.inputTitle = "修改";
      this.form = JSON.parse(JSON.stringify(row));
    },
    handleSuccess_cover(e) {
      console.log(e.data);
      this.form.url = e.data;
      console.log(this.form);
    },
    // 表单提交按钮
    sumbmitBtn() {
      console.log(this.form);
      if (this.form.storeName == "" || this.form.storeName == null) {
        this.$message.error("请填写店铺店铺名称");
        return;
      }
      // if (this.inputTitle == "新增") {
      //   addStore(this.form).then((res) => {
      //     console.log(res);
      //     if (res.code == 200) {
      //       this.dialogFormVisible = false;
      //       this.$message({
      //         type: "success",
      //         message: "新增店铺成功!",
      //       });
      //       this.selectFun();
      //     } else {
      //       this.$message({
      //         type: "info",
      //         message: "网路错误",
      //       });
      //     }
      //   });
      //   return;
      // }

      // updateStore(this.form).then((res) => {
      //   console.log(res);
      //   if (res.code == 200) {
      //     this.dialogFormVisible = false;
      //     this.$message({
      //       type: "success",
      //       message: "修改成功!",
      //     });
      //     this.selectFun();
      //   } else {
      //     this.$message({
      //       type: "info",
      //       message: "网络错误",
      //     });
      //   }
      // });
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          // deleteStore(row.id).then((resp) => {
          //   console.log(resp);
          //   this.$message({
          //     type: "success",
          //     message: "删除成功!",
          //   });
          //   this.selectFun();
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "会员卡号",
          "会员卡类型",
          "手机号",
          "交易金额",
          "交易时间",
          "备注",
        ];
        const filterVal = [
          "vip_number",
          "type",
          "user_phone",
          "amount",
          "create_time",
          "message",
        ];
        const list = this.dataList;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "会员交易记录下载",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
  },
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>
